/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { FaqCategoryDto } from '../../models/faq-category-dto';
import { FaqCategoryShowResponse } from '../../models/faq-category-show-response';

export interface PostFaqCategoryCreate$Params {
      body: FaqCategoryDto
}

export function postFaqCategoryCreate(http: HttpClient, rootUrl: string, params: PostFaqCategoryCreate$Params, context?: HttpContext): Observable<StrictHttpResponse<FaqCategoryShowResponse>> {
  const rb = new RequestBuilder(rootUrl, postFaqCategoryCreate.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<FaqCategoryShowResponse>;
    })
  );
}

postFaqCategoryCreate.PATH = '/v1/faq-category';
